import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import type { DashboardTab } from './Header';

const TAB_PATHS: Partial<Record<DashboardTab, string>> = {
  projects: '/projects',
  catalogue: '/catalogue',
  analytics: '/analytics',
  drawings: '/drawings',
};

/** Switching dashboard tabs (Header) from the page showing `current`. */
export function useDashboardTabNavigation(current: DashboardTab) {
  const navigate = useNavigate();
  return useCallback(
    (tab: DashboardTab) => {
      const path = TAB_PATHS[tab];
      if (tab !== current && path) navigate(path);
    },
    [current, navigate],
  );
}
